<template>
    <v-parallax :src="require('@/assets/background/Top.png')">
        <v-layout
                align-center
                column
                justify-center
                text-center
        >
        <v-avatar
                tile
        size=250>
                <img style="opacity: 0.6;" src="../assets/Logo.png" alt="Logo">
        </v-avatar>
            <h1 class="display-2 font-weight-thin mb-4" style="color: white">STAG Legal</h1>
          <!--
          <h4 class="subheading">
                Ihr b2b-Partner für telefonische und projektbezogene Rechtsberatung
            </h4> -->
    </v-layout>
      <!--
      <v-card dark width="200" max-height="220" style="position: absolute" color="green" height="100%" v-if="$vuetify.breakpoint.mdAndUp">
        <v-card-title>
          Ihre 24/7 Hotline
        </v-card-title>
        <v-card-subtitle>Wenn Sie uns nicht direkt erreichen, erfolgt unser Rückruf spätestens am folgenden Werktag.</v-card-subtitle>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large text href="tel:06171 95 69 99 96" :style="'font-size: 1rem'">06171 – 95 69 99 96</v-btn>
        </v-card-actions>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn x-large text href="mailto:mpu-online@stag-service.de?subject=Kontaktanfrage%20von%20der%20Webseite&amp;body=Sehr%20geehrter%20Herr%20Weiland,%0D%0A%0D%0A" >E-Mail</v-btn>

        </v-card-actions>
       
      </v-card>
      -->
    </v-parallax>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
